module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-63356e6a.png";